import React from 'react';
import Link from 'components/UI/Link';
import { pushCustomEvent } from 'utils/analytics';
import * as styles from './NavColumn.module.scss';

export default function NavColumn({ title, items }) {
  const handlePushEvent = label => {
    pushCustomEvent('ndrsn_footer', {
      action: 'click_on_link',
      label,
      pageUrl: window.location.href,
    });
  };
  return (
    <div className={styles.column}>
      {title && <p className={styles.title}>{title}</p>}
      {items?.map(({ title: label, link, target }) => {
        return (
          <Link
            key={label}
            href={link}
            target={target}
            className={styles.link}
            onClick={() => handlePushEvent(link)}
          >
            {label}
          </Link>
        );
      })}
    </div>
  );
}
